import { FormHeaderElement } from 'src/app/shared/models/app-models/FormHeaderElementList.model';
import { PurchaseOption } from '../../shared/models/app-models/PurchaseOption.model';
import moment from 'moment';
export const PurchaseOrderPopulator: PurchaseOption[] = [
  new PurchaseOption(
    1,
    'Request For Quotation',
    'Submit requisition to obtain quotations from vendors',
    '',
    'purchase/rfq/draft'
  ),
  new PurchaseOption(
    2,
    'Small Value Purchase',
    'Initiate a Purchase Order valued up to or equal S$6000 with quotation obtained',
    'Redirects to MMS',
    '',
    false
  ),
  new PurchaseOption(
    3,
    'Corporate Credit Card Purchase',
    'Initiate request for purchases that ONLY accepts credit card',
    '',
    'purchase/corporatecard/draft'
  ),
  new PurchaseOption(
    9,
    'Permissible Covering Purchase Order',
    'Initiate payment for Product/Services rendered under permissible categories',
    '',
    'purchase/permissiblecoveringpurchaseorder/draft'
  ),
];
export const PurchaseOrderImage: string = "/assets/images/trolly.svg";
export const PurchaseOrderTitle: string = "Purchase Order";
export const PurchaseOrderText: string = "A Purchase Order (PO) is a legally binding document created by a buyer and presented to a seller.";

export const ContractPopulator: PurchaseOption[] = [
  new PurchaseOption(
    6,
    'Tender',
    'Initiate tender process for purchase more than S$200,000',
    '',
    'purchase/tender/draft'
  ),
  new PurchaseOption(
    5,
    'Direct Contracting',
    'Initiate contract with single vendor without tender process',
    '',
    'purchase/dc/draft'
  ),
];
export const ContractImage: string = "/assets/images/contract.svg";
export const ContractTitle: string = "Contract";
export const ContractText: string = "A contract is created when there is an offer, consideration, and acceptance between two or more parties. ";


export const OthersPopulator: PurchaseOption[] = [
  new PurchaseOption(
    11,
    'Staff Reimbursement',
    'Obtain prior approval or to initiate reimbursement for out-of-pocket purchase ',
    ''
  ),
  new PurchaseOption(
    12,
    'Blanket Purchase Request',
    'Overarching approval for Approval of Requirement, Waiver of Competition and Staff Reimbursement prior approval for multiple purchase requests'
  ),
  new PurchaseOption(11, 'Reimbursement for Staff Welfare', 'For HR use only'),
  new PurchaseOption(
    13,
    'Exceptional Purchase Order',
    "For purchase order valued over S$200,000. Subject to Director PMM's approval"
  ),
  new PurchaseOption(4, 'Exercise option-to-purchase', ''),
];
export const OthersImage: string = "/assets/images/coming-soon.svg";
export const OthersTitle: string = "Others";
export const OthersText: string = "Other purchase modes.";

export const EnabledPurchaseTypes: string[] = [
  'request for quotation', 'tender', 'small value purchase', 'corporate credit card purchase', 
  'direct contracting', 'permissible covering purchase order',
]

export const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'DD/MM/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
}

export const convertSGTToUTC = (date: Date | string | undefined) => {
  if (!date) return date
  else {
    date = new Date(date)
    date.setHours(date.getHours() - 8)
    return date
  }
}

export const documentStatusPopulator = [
  new FormHeaderElement('Created By:', ''),
  new FormHeaderElement('Date Created:', moment(new Date()).format(MY_DATE_FORMAT.display.dateInput)),
  new FormHeaderElement('Document Status:', 'Unknown'),
  new FormHeaderElement('Document No:', '-'),
];

export const itemStatusPopulator = [
  new FormHeaderElement('Item No:', '')
];

export const PURCHASE_TYPE = {
  RFQ: 1,
  TENDER: 6,
  CORPORATECARD: 3,
  PERMISSIBLEREASON: 9
}

export const MP_ROLE_PREFIX = 'MP_'

export const documentNumberRegex = /^MPN[0-9]{9}$/m

export const VOLUNTEER_ICON = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icon/action/pan_tool">
<path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M23 20V5.5C23 4.67 22.33 4 21.5 4C20.67 4 20 4.67 20 5.5V11H19V2.5C19 1.67 18.33 1 17.5 1C16.67 1 16 1.67 16 2.5V11H15V1.5C15 0.67 14.33 0 13.5 0C12.67 0 12 0.67 12 1.5V11H11V4C11 3.17 10.33 2.5 9.5 2.5C8.67 2.5 8 3.17 8 4V15.91C8 15.91 3.73 13.46 3.69 13.45C3.51 13.35 3.31 13.29 3.09 13.29C2.79 13.29 2.52 13.39 2.3 13.58C2.26 13.6 1 14.83 1 14.83L8.85 22.81C9.6 23.57 10.62 24 11.7 24H19C21.2 24 23 22.2 23 20ZM15 13.545C15.545 12.905 16.38 12.5 17.25 12.5C18.79 12.5 20 13.71 20 15.25C20 17.1384 18.3028 18.6775 15.7313 21.0093L15.725 21.015L15 21.675L14.275 21.02L14.2553 21.0021C11.6913 18.6721 10 17.1352 10 15.25C10 13.71 11.21 12.5 12.75 12.5C13.62 12.5 14.455 12.905 15 13.545ZM15 20.325L15.05 20.275C17.43 18.12 19 16.695 19 15.25C19 14.25 18.25 13.5 17.25 13.5C16.48 13.5 15.73 13.995 15.47 14.68H14.535C14.27 13.995 13.52 13.5 12.75 13.5C11.75 13.5 11 14.25 11 15.25C11 16.695 12.57 18.12 14.95 20.275L15 20.325Z" fill="black" fill-opacity="0.87"/>
</g>
</svg>`

export const TRANSFER_ICON = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icon/image/crop_rotate" clip-path="url(#clip0_7622_98102)">
<path id="Vector" d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0C0.51 19.16 5.66 24 11.95 24C12.18 24 12.39 23.98 12.61 23.97L8.8 20.15L7.47 21.49ZM12.05 0C11.82 0 11.61 0.02 11.39 0.04L15.2 3.85L16.53 2.52C19.8 4.07 22.14 7.24 22.5 11H24C23.49 4.84 18.34 0 12.05 0Z" fill="black" fill-opacity="0.87"/>
<path id="Vector_2" d="M12 12C13.3812 12 14.5 10.8812 14.5 9.5C14.5 8.11875 13.3812 7 12 7C10.6188 7 9.5 8.11875 9.5 9.5C9.5 10.8812 10.6188 12 12 12ZM12 13.25C10.3312 13.25 7 14.0875 7 15.75V17H17V15.75C17 14.0875 13.6687 13.25 12 13.25Z" fill="black" fill-opacity="0.87"/>
</g>
<defs>
<clipPath id="clip0_7622_98102">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`

export const RECOMMEND_ICON = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 17.35H14.75C14.9833 17.35 15.1792 17.3 15.3375 17.2C15.4958 17.1 15.6333 16.95 15.75 16.75L17.7 12.2C17.7333 12.1167 17.7625 11.9917 17.7875 11.825C17.8125 11.6583 17.825 11.5333 17.825 11.45V10.85C17.825 10.6167 17.7708 10.4458 17.6625 10.3375C17.5542 10.2292 17.3833 10.175 17.15 10.175H11.8L12.525 6.725C12.5583 6.59167 12.5583 6.46667 12.525 6.35C12.4917 6.23333 12.4333 6.13333 12.35 6.05L11.825 5.5L7.8 9.85L7.6 10.25C7.53333 10.3833 7.5 10.525 7.5 10.675V15.85C7.5 16.2333 7.65 16.5792 7.95 16.8875C8.25 17.1958 8.6 17.35 9 17.35ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.02917 5.825 4.9375 4.925C5.84583 4.025 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.975 18.1542 19.075 19.0625C18.175 19.9708 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20.5C14.3667 20.5 16.375 19.6708 18.025 18.0125C19.675 16.3542 20.5 14.35 20.5 12C20.5 9.63333 19.675 7.625 18.025 5.975C16.375 4.325 14.3667 3.5 12 3.5C9.65 3.5 7.64583 4.325 5.9875 5.975C4.32917 7.625 3.5 9.63333 3.5 12C3.5 14.35 4.32917 16.3542 5.9875 18.0125C7.64583 19.6708 9.65 20.5 12 20.5Z" fill="black"/>
</svg>`
